import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface BulkValuePickerProps {
  label: string
  options: ReadonlyArray<{ value: string; label: string }>
  onSelect: (value: string) => void
  icon?: React.ReactNode
}

/**
 * Compact dropdown button used in the bulk-actions floating bar to apply a
 * single value (status, severity, phase, stage) across many selected rows.
 */
export function BulkValuePicker({
  label,
  options,
  onSelect,
  icon,
}: BulkValuePickerProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            'h-7 px-2 text-xs text-background hover:bg-background/15 hover:text-background gap-1',
          )}
        >
          {icon}
          {label}
          <ChevronDown className="h-3 w-3 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center">
        {options.map((opt) => (
          <DropdownMenuItem key={opt.value} onClick={() => onSelect(opt.value)}>
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
